/* BELLY — shared behaviour. Load once in layout/theme.liquid with a deferred script tag pointing at belly.js */
(function(){
  var d=document.documentElement; d.classList.add('b-js');
  function reveal(){
    var els=[].slice.call(document.querySelectorAll('.b-reveal:not(.is-in)'));
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  if(document.readyState!=='loading')reveal();else document.addEventListener('DOMContentLoaded',reveal);
  document.addEventListener('shopify:section:load',reveal);
  /* Referrals: a friend arrives on ?ref=<customer id>. Keep it for 60 days and put it on their cart as the hidden _ref
     attribute, so it lands on their first order. Shopify Flow pays the referrer $30 store credit once that box is delivered. */
  (function(){
    var K='belly-ref',ref=null;
    try{var m=location.search.match(/[?&]ref=(\d{5,20})\b/);
      if(m)localStorage.setItem(K,JSON.stringify({id:m[1],t:Date.now()}));
      var s=JSON.parse(localStorage.getItem(K)||'null');if(s&&Date.now()-s.t<5184e6)ref=s.id;}catch(e){}
    if(!ref)return;window.bellyRef=ref;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      if((c.attributes||{})._ref===ref)return;
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_ref:ref}})});
    }).catch(function(){});
  })();
  /* Any link or button marked data-b-calc-open opens the feeding guide (on this page, or in Build your box). */
  /* Also any link to #feeding written in the theme editor (rich text can't carry data attributes), but only on a page with the
     calculator section; elsewhere #feeding is an ordinary anchor (the FAQ uses it for a heading). */
  document.addEventListener('click',function(e){var a=e.target.closest('[data-b-calc-open],a[href="#feeding"]');if(!a)return;
    if(!a.hasAttribute('data-b-calc-open')&&!document.querySelector('section.b-feed#feeding'))return;
    e.preventDefault();document.dispatchEvent(new Event('belly:calc'));});
})();
